/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import GameSetup from '../Game/GameSetup';
import LocalizationComponent from '../Localization/LocalizationComponent';
import NodeTouchActionComponent from '../Utility/Component/Action/NodeTouchActionComponent';
import InjectableComponent from '../Utility/Component/ComponentReference/InjectableComponent';
import PopupModal from '../Utility/Component/Popup/PopupModal';
import {AutoPlayManager} from "./AutoPlayManager";

/** A [[NodeTouchActionComponent]] for returning the player to the lobby address specified in the [[GameSetup]]. */
@cc._decorator.ccclass
export default class LobbyAction extends NodeTouchActionComponent
{
    /** @hidden */
    private _gameSetupRef: InjectableComponent<GameSetup> = new InjectableComponent();
    /** @hidden */
    private _popupModalRef: InjectableComponent<PopupModal> = new InjectableComponent();
    /** @hidden */
    private _localRef: InjectableComponent<LocalizationComponent> = new InjectableComponent();
    /** @hidden */
    private _autoPlayManagerRef: InjectableComponent<AutoPlayManager> = new InjectableComponent();

    /** @hidden */
    private dialogOpen: boolean = false;

    /** @hidden */
    protected setContexts(): void
    {
        this._gameSetupRef.SetContext(GameSetup);
        this._popupModalRef.SetContext(PopupModal);
        this._localRef.SetContext(LocalizationComponent);
        this._autoPlayManagerRef.SetContext(AutoPlayManager);
    }

    /** @hidden */
    protected action = () =>
    {
        if (!this.dialogOpen)
        {
            this._autoPlayManagerRef.Value.PauseAutoPlay();
            this._popupModalRef.Value.Show('',
            {
                MessageId: "lobby",
                Title: this._localRef.Value.GetStringResource('Menu/Exit_to_lobby'),
                FnOnOK: () =>
                {
                    this._gameSetupRef.Value.LobbyWindow.location.href = this._gameSetupRef.Value.LobbyURL;
                },
                IncludeOkButton: true,
                FnOnCancel: () =>
                {
                    this.dialogOpen = false;
                },
                IncludeCancelButton: true,
                ClickOffToExit: true
            });

            this.dialogOpen = true;
        }
    }
}
